import { openHeaderMenu, subheadingFixed } from "../../header/headerMenus.js";
import { getCurrentQuery } from "../../utils.js";

export function needLogin() {
    const needLoginQuery = getCurrentQuery().find(item => item.need_login)?.need_login;
    if(!needLoginQuery) return;
    openHeaderMenu('login');
    subheadingFixed();
}